import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceRequestHistoryUnit from './ServiceRequestHistoryUnit'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'registration-information/history',
    name:
        'serviceRequest.registration-information.history',
    component: ServiceRequestHistoryUnit,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
